/*
 * @Description: 商城配置数据
 * @Autor: WangYuan
 * @Date: 2021-09-28 15:05:58
 * @LastEditors: Yehon He 1427749162@qq.com
 * @LastEditTime: 2024-12-24 00:04:44
 */

export const mallTypeList = [
    {
        type: 'mall',
        logo: 'http://manage.fankeymice.com/top_logo.png',
        title: 'E健云',
        subTitle: ' E-commence'
    },
    {
        type: 'model',
        logo: 'http://manage.fankeymice.com/top_logo.png',
        title: '商城模板',
        subTitle: ' E-commenceModel'
    },
]

export const mallIndustryList = [
    { label: '日用百货', value: 'department' },
    { label: '服饰饰品', value: 'clothes' },
    { label: '休闲零食', value: 'snacks' },
    { label: '数码家电', value: 'digital' },
    { label: '教育培训', value: 'education' },
    { label: '酒店旅游', value: 'hotel' },
    { label: '其他', value: 'other' },
]